module.exports = __webpack_public_path__ + "img/logo.8463a104.png";